// mui
import { isAutogeneratedRow } from '@mui/x-data-grid-premium';
// types
import { ReportColumnDto } from 'src/api';
// constants
import { numberAggregationModels } from '../constants/aggregation-model/number';

export function ClassAttendancePercentageColumn(index: number) {
  const column = {
    field: 'classAttendancePercentage',
    headerName: 'Class attendance percentage',
    description: 'The percentage of attendance for the class',
    type: 'number',
    width: 150,
    index,
    groupable: true,
    availableAggregationFunctions: numberAggregationModels,
    headerAlign: 'center',
    align: 'center',
    valueFormatter: (value: any, row: any) => {
      if (isAutogeneratedRow(row)) {
        return value;
      }
      if (!value) {
        return null;
      }
      return `${value.toFixed(2)} %`;
    },
  } as ReportColumnDto<any, any, any>;
  return column;
}
